<template>
  <el-popover width="260" popper-class="design-icon-popper" trigger="click" :placement="placement">
    <div class="item-list colors" v-if="!_.isEmpty(colors)">
      <div
        v-for="(color, index) in colors"
        :key="index"
        class="add-color pointer"
        :class="{ active: curData.color ? curData.color === color : index === 0 }"
        :style="{ background: color }"
        @click="changeData('color', color)"
      >
        <i
          class="el-icon-check"
          v-if="curData.color ? curData.color === color : index === 0"
          :style="from === 'button' && color === '#f5f7fa' ? '' : 'color: #fff;'"
        ></i>
      </div>
    </div>
    <div class="item-list icons" v-ps style="height: 240px">
      <div
        v-for="(icon, index) in icons"
        :key="index"
        class="add-icon pointer"
        :style="getStyle(icon, index)"
        @click="changeData('icon', icon)"
      >
        <svg-icon :icon-class="from + '_' + icon" :style="getIconStyle(icon, index)"></svg-icon>
      </div>
    </div>
    <span slot="reference" class="pointer" style="color: #1989FA;">
      更换图标
    </span>
  </el-popover>
</template>
<script>
export default {
  name: "design-icon-popper",
  props: {
    colors: {
      type: Array,
      default: () => []
    },
    icons: Array,
    curData: {
      type: Object,
      default: () => ({})
    },
    placement: {
      type: String,
      default: "bottom"
    },
    from: String
  },
  data() {
    return {}
  },
  methods: {
    changeData(key, val) {
      this.$emit("changeData", key, val)
    },
    getStyle(icon, index) {
      let isActive = this.curData.icon ? this.curData.icon === icon : index === 0
      switch (this.from) {
        case "sheet":
          return isActive ? { border: "1px solid #dcdfe6" } : {}
        case "project":
          return Object.assign(
            { background: "#1989fa" },
            isActive ? { opacity: 0.64, "box-shadow": "0 0 2px 3px #dcdfe6" } : {}
          )
        case "button":
        case "app":
          return Object.assign(
            { background: this.curData.color ? this.curData.color : this.colors[0] },
            isActive ? { opacity: 0.64, "box-shadow": "0 0 2px 3px #dcdfe6" } : {}
          )
        default:
          return {}
      }
    },
    getIconStyle(icon, index) {
      switch (this.from) {
        case "sheet":
          return {
            color: this.curData.color ? this.curData.color : this.colors[0],
            "font-size": "20px"
          }
        case "button":
          return {
            color: !this.curData.color || this.curData.color === "#f5f7fa" ? "#313132" : "#fff",
            "font-size": "20px"
          }
        default:
          return { color: "#fff", "font-size": "20px" }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.design-icon-popper {
  .colors {
    border-bottom: 2px solid #f5f5f5;
  }
  .icons {
    margin-top: 12px;
  }
  .item-list {
    padding: 3px;
    display: flex;
    flex-wrap: wrap;
    .add-color {
      width: 30px;
      height: 30px;
      border-radius: 6px;
      margin: 5px 12px 13px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      &.active {
        opacity: 0.64;
        box-shadow: 0 0 2px 3px #dcdfe6;
      }
    }
    .add-icon {
      width: 30px;
      height: 30px;
      margin-right: 12px;
      margin-bottom: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      border-radius: 6px;
    }
  }
}
</style>
